import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-study',
  templateUrl: './edit-study.component.html',
  styleUrl: './edit-study.component.scss'
})
export class EditStudyComponent {
 

  constructor() { }


  ngOnInit(): void {}




}
